import { Autocomplete, Grid, TextField } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import colors from "assets/theme/base/colors";

import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";

import useModal from "hooks/useModal";

import MDBox from "components/MDBox";

import { useState } from "react";
import useAuth from "hooks/useAuth";
import { dashCards } from "utils/utils";

const DashboardWidgetModal = () => {
  const { closeModal } = useModal();
  const { auth } = useAuth();

  auth.profile.dashboardConfig;

  const options = dashCards.filter(
    (card) => !auth.profile.dashboardConfig.some((config) => config.id === card.id)
  );

  const [inputVal, setInputVal] = useState("");
  const [survey, setSurvey] = useState();
  const [surveysError, setSurveysError] = useState(false);

  return (
    <div style={{ minWidth: 500 }}>
      <MDBox display="flex" flexDirection="column" textAlign="center">
        <MDTypography
          display="inline"
          variant="h6"
          textTransform="capitalize"
          fontWeight="bold"
          textAlign="center"
        >
          Add Widget
        </MDTypography>
      </MDBox>
      <Grid container spacing={1} mb={1} mt={0.5}>
        <Grid container spacing={1} mb={1} mt={1}>
          <Grid item xs={3} textAlign="right">
            <MDTypography display="inline" variant="body2" textTransform="capitalize">
              Select Widget
            </MDTypography>
          </Grid>
          <Grid item xs={8} textAlign="left" pr={2}>
            <Autocomplete
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={survey || null}
              onChange={(event, newValue) => {
                setSurvey(newValue);
              }}
              inputValue={inputVal}
              onInputChange={(event, newInputValue) => {
                setSurveysError(false);
                setInputVal(newInputValue);
              }}
              options={options}
              renderInput={(params) => (
                <TextField
                  error={surveysError}
                  helperText={surveysError ? "Please select a Pathway" : ""}
                  {...params}
                  placeholder="Select a Pathway..."
                />
              )}
              renderOption={(props, option, { inputValue }) => {
                const matches = match(option.label, inputValue, { insideWords: true });
                const parts = parse(option.label, matches);

                const bgColor = inputValue === option.label ? colors.grey[200] : null;
                return (
                  <li {...props} style={{ backgroundColor: bgColor }}>
                    <div>
                      {parts.map((part) => (
                        <span
                          key={part.text + new Date().getTime()}
                          style={{
                            fontWeight: part.highlight ? 700 : 400,
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {part.text}
                        </span>
                      ))}
                    </div>
                  </li>
                );
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <MDBox p={2} display="flex" textAlign="center" alignItems="center" justifyContent="center">
        <MDBox mr={1}>
          <MDButton
            onClick={() => closeModal({ action: "cancel" })}
            variant="gradient"
            color="light"
            size="medium"
            m={1}
          >
            cancel
          </MDButton>
        </MDBox>
        <MDBox mr={1}>
          <MDButton
            onClick={() =>
              closeModal({
                action: "add",
                widget: survey.id,
              })
            }
            variant="gradient"
            color="info"
            size="medium"
          >
            add
          </MDButton>
        </MDBox>
      </MDBox>
    </div>
  );
};

export default DashboardWidgetModal;
